function getParams () {
  var url = window.location.href // 获取当前页面的URL地址
  var params = url.split('?')[1] // 以问号为分隔符将URL分成两份，取第二份
  var paramObj = {} // 声明一个空对象，用于保存参数
  if (params) {
    var paramArr = params.split('&') // 以&为分隔符将参数分割成数组
    for (var i = 0; i < paramArr.length; i++) {
      var keyValue = paramArr[i].split('=') // 以=为分隔符将键值对分割成数组
      var key = keyValue[0] // 取键
      var value = keyValue[1] // 取值
      paramObj[key] = value // 将键值对存入对象
    }
  }
  return paramObj
}
export default getParams



// WEBPACK FOOTER //
// ./src/utils/getParams.js